import { render } from "./prescription_invoice.vue?vue&type=template&id=e5f12146"
import script from "./prescription_invoice.vue?vue&type=script&lang=js"
export * from "./prescription_invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__